export const fetchConfig = async (): Promise<any> => {
  const pluginHost = window.location.origin;
  const configUrl = `${pluginHost}/config.js?timestamp=${Date.now()}`;
  const response = await fetch(configUrl);
  if (!response.ok) throw new Error("config.js not found");
  const scriptText = await response.text();
  new Function(scriptText)(); // Executes config script
  return window.OE_PLUGIN_CONFIG;
};
